/* eslint-disable react/no-danger */
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from '../../../i18n';
import { actions as ratesActs, DeliveryType, selectors as fromRates } from '../../../entities/rates';
import * as fromProviders from '../../../entities/providers/selectors';

import { Button } from '../../element';
import { SweetModal } from '../../ui/modal/sweet-modal';

export const CourierModal: React.FC = () => {
  const [t] = useTranslation('rates');

  const dispatch = useDispatch();

  const [opened, setOpen] = useState(false);
  const [remember, setRemember] = useState(false);

  const delivery: DeliveryType = useSelector(fromRates.getDeliveryType);
  const deliveryDiff: string = useSelector(fromProviders.getParcelDeliveryDiff);
  const postCode: string = useSelector(fromRates.getReceiverPostCode);
  const hasCourier: boolean = useSelector(fromRates.getReceiverPostCodeHasCourier);

  useEffect(() => {
    if (postCode) {
      // add small delay
      setTimeout(() => {
        dispatch(ratesActs.fetchPostCodeCourier());
      }, 1000);
    } else {
      setOpen(false);
    }
  }, [postCode]);

  useEffect(() => {
    if (!remember && delivery !== DeliveryType.courier && hasCourier) {
      setOpen(true);
    }
  }, [remember, hasCourier, delivery]);

  const handleClose = useCallback(() => {
    setOpen(false);
    setRemember(true);
  }, []);

  const setCourierDelivery = useCallback(() => {
    dispatch(ratesActs.setDelivery({ delivery: DeliveryType.courier }));

    handleClose();
  }, [handleClose]);

  if (opened) {
    return (
      <SweetModal center closable={false} open={opened} onClose={handleClose}>
        <div className="mb-30">
          <span dangerouslySetInnerHTML={{ __html: t('rates.modal.content', { deliveryDiff }) }} />
        </div>

        <Button type="primary" nativeType="button" onClick={setCourierDelivery}>
          {t('rates.modal.confirm', { deliveryDiff })}
        </Button>

        <Button type="text" onClick={handleClose}>
          {t('rates.modal.decline')}
        </Button>
      </SweetModal>
    );
  }

  return null;
};
